export const APP_VERSION = "1.6.2";

export const SUBSCRIPTION_DISCOUNT = 0.1;
export const SHIPMENT_PRICE = 3.95;
export const CUSTOMIZER_MAX_IMAGES_COUNT = 3;
export const CANVAS_WIDTH = 900;
export const CANVAS_HEIGHT = 1200;
